import { MemoizedSelector, createSelector } from "@ngrx/store";
import { MediaDownloadState, MediaFeatureState } from "../states";
import { selectMediaFeatureState } from "./media-feature.selectors";



export const selectDownloadMediaState: MemoizedSelector<object, MediaDownloadState> = createSelector(selectMediaFeatureState, (state: MediaFeatureState) => state.mediaDownload);


const getDownloaded = (state: MediaDownloadState): boolean => state.donwloded;
const getNumber = (state: MediaDownloadState): number => state.selected
const getEditId = (state: MediaDownloadState): number => state.editId

export const selectDownloading: MemoizedSelector<object, boolean> = createSelector(selectDownloadMediaState, getDownloaded);
export const selectNumber: MemoizedSelector<object, number> = createSelector(selectDownloadMediaState, getNumber);
export const selectId: MemoizedSelector<object, number> = createSelector(selectDownloadMediaState, getEditId);